<dialog
  #deleteDialog
  qai-dialog
  [description]="''"
  (afterClose)="handleClose()"
>
  <div class="icon">
    <qai-icon kind="trash" size="24px"></qai-icon>
  </div>
  <div class="title">{{ heading }}</div>
  <div class="content">{{ content }}</div>

  <div class="modal-actions">
    <button qai-button kind="secondary" size="medium" (click)="handleClose()">Cancel</button>
    <button
      qai-button
      kind="destructive"
      size="medium"
      [disabled]="networkRequestInProgress || isDeleteDisabled"
      (click)="handleDelete()"
    >
      {{ deleteLabel }}
    </button>
  </div>
</dialog>
